export { Faqcomponent } from './components/Faq/FaqComponent';
export * from './components/NotificationsArray';
export * from './store';
